<template>
  <div class="row">
    <div class="col-12">
      <h5> {{ $t('checkup_plus.person.measurements.create.data_to_insert') }}</h5>
    </div>
    <div class="col-12 d-flex">
      <div class="col-6 form-group">
        <va-date-picker
          class="w-100"
          v-model="form.date"
          :placeholder="$t('iframe.table_headings.created_at')"
          :label="$t('iframe.table_headings.created_at')"
          :config="{
            defaultDate: appointmentDates.start,
            enableTime: true,
            maxDate: moment(appointmentDates.end).toDate(),
            minDate: moment(appointmentDates.start).toDate(),
            time_24hr: true,
            minuteIncrement: 15,
            dateFormat: 'Y/m/d H:i'}"
        />
      </div>
        <div class="col-6 form-group">
          <va-input
            type="number"
            step="0.1"
            max="100"
            min="0"
            :error="errors.bloodHematocrit.length > 0"
            :error-messages="errors.bloodHematocrit"
            v-model="form.bloodHematocrit"
            :placeholder="$t('dashboard_new_evollu.measurement_types.blood_hematocrit_short')+' (%)'"
            :label="$t('dashboard_new_evollu.measurement_types.blood_hematocrit_short')+' (%)'"
            required
            :v-bind:class="{'error': true}"
          />
        </div>

    </div>

    <div class="col-12 d-flex">
      <div class="col-6 form-group">
        <va-input
          type="number"
          step="0.1"
          min="0"
          :error="errors.bloodErythocytes.length > 0"
          :error-messages="errors.bloodErythocytes"
          v-model="form.bloodErythocytes"
          :placeholder="$t('dashboard_new_evollu.measurement_types.blood_erythocytes_short')+ ' (million/mm3)'"
          :label="$t('dashboard_new_evollu.measurement_types.blood_erythocytes_short')+ ' (million/mm3)'"
          required
          :v-bind:class="{'error': true}"
        />
      </div>

      <div class="col-6 form-group">
        <va-input
          type="number"
          step="0.1"
          min="0"
          :error="errors.bloodHemoglobin.length > 0"
          :error-messages="errors.bloodHemoglobin"
          v-model="form.bloodHemoglobin"
          :placeholder="$t('dashboard_new_evollu.measurement_types.blood_hemoglobin_short')+' (g/dL)'"
          :label="$t('dashboard_new_evollu.measurement_types.blood_hemoglobin_short')+' (g/dL)'"
          required
          :v-bind:class="{'error': true}"
        />
      </div>

    </div>

  </div>
</template>

<script>
import moment from "moment";
const BLOOD_HEMATOCRIT_TYPE_ID = 108
const BLOOD_ERYTHOCYTES_TYPE_ID = 109
const BLOOD_HEMOGLOBIN_TYPE_ID = 110

export default {
  props: {
    measurement: {
      type: Object,
      required: true
    },
    appointmentDates: {
      type: Object,
      mandatory: true,
    },
  },
  data() {
    return {
      form: {
        date: this.appointmentDates.start,
        bloodHematocrit: null,
        bloodErythocytes: null,
        bloodHemoglobin: null,
      },
      errors: {
        bloodHematocrit: [],
        bloodErythocytes: [],
        bloodHemoglobin: [],
      }
    }
  },
  created() {
    this.measurement.measurementTypeId = 26
  },
  methods: {
    checkCanSubmit() {
      let canSubmit = (this.form.bloodHematocrit !== null && this.form.bloodHematocrit !== '') ||
        (this.form.bloodErythocytes !== null && this.form.bloodErythocytes !== '') ||
        (this.form.bloodHemoglobin !== null && this.form.bloodHemoglobin !== '')

        this.$emit('updateCanSubmit', canSubmit)
    }
  },
  watch: {
    "form.bloodHematocrit": function(value) {
        if(value !== '' && (value < 0 || value > 100)) {
          this.errors.bloodHematocrit = [this.$t('checkup_plus.person.measurements.create.messages.errors.value_must_be_between_min_max', {min: 0, max: 100})]
        }
        else {
          this.errors.bloodHematocrit = []
        }

        if(this.measurement.measurements.find(meas => meas.typeId === BLOOD_HEMATOCRIT_TYPE_ID)) {
          let elem = this.measurement.measurements.find(meas => meas.typeId === BLOOD_HEMATOCRIT_TYPE_ID)
          elem.value = this.errors.bloodHematocrit.length === 0 ? value : null
        } else {
          this.measurement.measurements.push({
            value: this.errors.bloodHematocrit.length === 0 ? value : null,
            typeId: BLOOD_HEMATOCRIT_TYPE_ID
          })
        }
      this.checkCanSubmit()
    },
    "form.bloodErythocytes": function(value) {
      if(value !== '' && (value <= 0)) {
        this.errors.bloodErythocytes = [this.$t('checkup_plus.person.measurements.create.messages.errors.value_must_be_higher_than', {value: 0})]
      }
      else {
        this.errors.bloodErythocytes = []
      }

      if(this.measurement.measurements.find(meas => meas.typeId === BLOOD_ERYTHOCYTES_TYPE_ID)) {
        let elem = this.measurement.measurements.find(meas => meas.typeId === BLOOD_ERYTHOCYTES_TYPE_ID)
        elem.value = this.errors.bloodErythocytes.length === 0 ? value : null
      } else {
        this.measurement.measurements.push({
          value: this.errors.bloodErythocytes.length === 0 ? value : null,
          typeId: BLOOD_ERYTHOCYTES_TYPE_ID
        })
      }
      this.checkCanSubmit()
    },
    "form.bloodHemoglobin": function(value) {
      if(value !== '' && (value <= 0)) {
        this.errors.bloodHemoglobin = [this.$t('checkup_plus.person.measurements.create.messages.errors.value_must_be_higher_than', {value: 0})]
      }
      else {
        this.errors.bloodHemoglobin = []
      }

      if(this.measurement.measurements.find(meas => meas.typeId === BLOOD_HEMOGLOBIN_TYPE_ID)) {
        let elem = this.measurement.measurements.find(meas => meas.typeId === BLOOD_HEMOGLOBIN_TYPE_ID)
        elem.value = this.errors.bloodHemoglobin.length === 0 ? value : null
      } else {
        this.measurement.measurements.push({
          value: this.errors.bloodHemoglobin.length === 0 ? value : null,
          typeId: BLOOD_HEMOGLOBIN_TYPE_ID
        })
      }
      this.checkCanSubmit()
    },
    appointmentDates: {
      immediate: true,
      deep:true,
      handler (value) {
        this.form.date = value.start
        this.measurement.date = moment(value.start).valueOf()
      }
    },
    'form.date': function (value) {
      if(value !== null) {
        this.measurement.date = moment(value).valueOf()
      } else {
        this.measurement.date = null
      }
    }
  }
}
</script>

<style scoped>

</style>
